// extracted by mini-css-extract-plugin
export default {"button":"GoBackButton_button__n5WpT"};